/**
 * 모바일 관리자 — 목록에서 불러톡 대화창으로 나갔다가 **보던 자리로** 돌아오기.
 *
 * 대화창(/ma/chat/room)은 location.replace 로 드나든다. 돌아오면 목록이 처음부터 다시
 * 그려지므로 스크롤·검색조건·불러온 쪽수가 전부 사라진다 — 나가기 직전에 적어 두고,
 * 돌아온 화면이 그걸로 목록을 다시 세운 뒤 스크롤을 맞춘다.
 *
 * 복원은 **대화창에서 곧바로 돌아온 그 한 번**뿐이다(referrer 로 판정). 대화창을 다른 길로
 * 빠져나가면 적어 둔 것이 남는데, 그걸 나중에 하단탭으로 들어온 목록에 씌우면 안 고른
 * 조건이 걸린 화면이 뜬다. 그래서 take 는 맞든 안 맞든 읽는 즉시 지운다.
 */
const KEY = 'ma:chat:listReturn';   // sessionStorage (.ai/state-management.md)
const ROOM_PATH = '/ma/chat/room';

/**
 * @param {string} page   목록 구분 ('chat' | 'members')
 * @param {object} state  그 목록이 스스로 되살릴 재료 (검색조건·불러온 건수 등)
 */
export function saveListReturn(page, state = {}) {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    $j.Common.Store.session.setJSON(KEY, Object.assign({}, state, { page, y }));
}

/** 적어 둔 상태를 꺼낸다(1회). 이 목록 것이 아니거나 대화창에서 온 게 아니면 null */
export function takeListReturn(page) {
    const s = $j.Common.Store.session.getJSON(KEY);
    $j.Common.Store.session.remove(KEY);
    if (!s || s.page !== page) return null;
    if ((document.referrer || '').indexOf(ROOM_PATH) < 0) return null;
    return s;
}

/** 목록을 다 그린 뒤 부른다 — 그리기 전에는 문서가 짧아 그 자리까지 못 내려간다 */
export function restoreScroll(y) {
    if (!(y > 0)) return;
    requestAnimationFrame(() => window.scrollTo(0, y));
}
